import { request } from "services/api/util";

class CrmTriggerTypeService {
  async getListCrmTriggerType(param) {
    const config = {
      method: "get",
      url: `admin/crmTriggers/types`,
      params: param,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }
}

export default new CrmTriggerTypeService();
